import api from "@/api/axiosInstance";

type PortenType = "PULSE" | "HSEQ_DASHBOARD";

type Product = {
    id: number;
    name: string;
    createdAt: string;
    type: string;
    compublishId: number;
    blockProduct: boolean;
    portenType?: PortenType;
};

type ProductInstance = {
    name: string;
    id: number;
    productId: number;
    compublishId: number;
    url: string;
    newTemplate: boolean;
    slug: string;
    deletedAt: string | null;
    disabledAt: string | null;
    portenType: string | null;
    customerId: number;
    updatedById: number;
    product?: Product;
};

const getAllProductInstances = async (): Promise<ProductInstance[]> => {
    try {
        const response = (await api.get("admin/product-instances")).data;
        return response.data;
    } catch (err) {
        throw new Error(
            `Error fetching subscribed products: ${err instanceof Error ? err.message : err}`,
        );
    }
};

export { getAllProductInstances };

export type { ProductInstance };
